import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { auth } from './firebase';
import vuetify from './plugins/vuetify';

import './plugins/axios';
import './plugins/veeValidate';

Vue.config.productionTip = false;

let app;
auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      vuetify,
      render: (h) => h(App),
    }).$mount('#app');
  }
});
